module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-tootip"
  }, [_c('div', {
    staticClass: "mt-tooltip"
  }, [_vm._v(_vm._s(_vm.cutString(_vm.content, _vm.countCut)) + "\n\t\t"), _c('span', {
    staticClass: "mt-tooltip__tooltiptext"
  }, [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51536cda","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/tooltip/Tooltip.vue
// module id = aD9i
// module chunks = 0